import script from "./ArticleItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArticleItem.vue?vue&type=script&lang=ts&setup=true"

import "./ArticleItem.vue?vue&type=style&index=0&id=2283a5b9&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2283a5b9"]])

export default __exports__